import { MenuItem, MenuItemWithSubMenu, SubMenu, type MenuItemProps } from '@/components/Menu'
import { useAuth } from '@/context/AuthContext'
import { carkulkaOffersContext } from '@/context/CarkulkaOffersProvider'
import { useApp } from '@/hooks/useApp'
import { useGetOfferDocuments } from '@/hooks/useDocuments'
import { Spinner } from '@chakra-ui/react'
import type { Document } from 'BrokerTsLib/src/dtos'
import { Product } from 'BrokerTsLib/src/enums'
import { format } from 'date-fns'
import { useContext, useEffect } from 'react'

const documentVehicleUrl = import.meta.env.VITE_DOCUMENT_VEHICLE_API
const documentTravelUrl = import.meta.env.VITE_DOCUMENT_TRAVEL_API
const documentPropertyUrl = import.meta.env.VITE_DOCUMENT_PROPERTY_API
const documentLiabilityUrl = import.meta.env.VITE_DOCUMENT_LIABILITY_API

export const useUrl = () => {
  const { product } = useApp()

  let url: string | undefined = ''

  switch (product) {
    case Product.TravelInsurance: url = documentTravelUrl; break
    case Product.PropertyInsurance: url = documentPropertyUrl; break
    case Product.LiabilityInsurance: url = documentLiabilityUrl; break
    default: url = documentVehicleUrl; break
  }

  return `/${url}`
}

export const OfferDocuments = ({ offerId, ...props }: { offerId: number } & Omit<MenuItemProps, 'children'>) => {
    const { user } = useAuth()

    if (!user?.enableOfferXml)
        return null

    return <MenuItemWithSubMenu trigger='click'
        button={
            <MenuItem
                variant="outline" colorScheme='gray' color="gray.500"
                {...props}
                >
                XML
            </MenuItem>
        }
        subMenu={<OfferDocumentsContent offerId={offerId} />}
    />

}


export const OfferDocumentsContent = ({ offerId }: { offerId: number }) => {
    const { calculatingOffersIds } = useContext(carkulkaOffersContext)
    const isRecalculating = calculatingOffersIds?.includes(offerId) ?? false

    const { refetch: getOfferDocuments, data: offerDocuments, isLoading } = useGetOfferDocuments(offerId)

    useEffect(() => {
        if (!isRecalculating) {
            getOfferDocuments()
        }
    }, [getOfferDocuments, isRecalculating])

    const documentUrl = useUrl()

    return isLoading ? <Spinner /> : <SubMenu sx={{
        maxHeight: '300px',
        overflow: 'auto',
        p: 2,
        width: 'max-content',
        position: 'absolute',
        top: '100%',
        left: 0,
        bg: 'white',
        borderRadius: 'md',
        boxShadow: 'md',
        listStyle: 'none',
        zIndex: 'subMenu'
    }}
    >
        <li>
            {offerDocuments?.data.map((doc: Document) => {
                return (
                    <MenuItem key={doc.id} target='_blank' href={`${documentUrl}/GetOfferDocument?docId=${doc.id}`}><>{doc.name} ({format(new Date(doc.date), 'd.M.yyyy H:mm:ss')})</></MenuItem>
                )
            })}
            {offerDocuments?.data.length === 0 && <MenuItem>Žádné dokumenty</MenuItem>}
        </li>
    </SubMenu>
}